module.exports = __webpack_public_path__ + "img/lau.c260838.webp";